  // =====================
  // ベツダイホームの家づくりスライダー
  // =====================
document.addEventListener("DOMContentLoaded", function () {
  const mainElLineup = document.querySelector(".lineup-slide__main");

  if (mainElLineup) {
    const lineupSlider = new Splide(mainElLineup, {
      type: "loop", // ループさせる
      focus: "center", // アクティブなスライドを中央に配置
      padding: "15%", // 左右のスライドのチラ見せ幅
      gap: "40px", // スライド間の余白
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      pagination: false,
      arrows: false, // デフォルトの矢印を非表示
      speed: 600,
      breakpoints: {
        599: {
          padding: "10%",
          gap: "20px",
        },
      },
    });

    // カウンターの処理
    const counterElLineup = document.querySelector(".lineup-slide__counter");

    if (counterElLineup) {
      const updateCounter = (index) => {
        counterElLineup.textContent = `${index + 1} / ${lineupSlider.length}`;
      };
      lineupSlider.on("mounted moved", () => updateCounter(lineupSlider.index));
    }

    // スライダーの初期化
    lineupSlider.mount();

    // 外部矢印ボタンの処理
    const prevBtnLineup = document.querySelector(
      ".lineup-slide__controls .splide__arrow--prev",
    );
    const nextBtnLineup = document.querySelector(
      ".lineup-slide__controls .splide__arrow--next",
    );

    if (prevBtnLineup && nextBtnLineup) {
      prevBtnLineup.addEventListener("click", () => lineupSlider.go("<"));
      nextBtnLineup.addEventListener("click", () => lineupSlider.go(">"));
    }
  }
});

// =====================
// ずっと好きでいられる家づくりページ　スライダー
// =====================
const mainElLineup = document.querySelector(".lineup-slide__main");

if (mainElLineup) {
  const lineupSlider = new Splide(mainElLineup, {
    type: "loop", // ループさせる
    focus: "center", // アクティブなスライドを中央に配置
    padding: "15%", // 左右のスライドのチラ見せ幅
    gap: "40px", // スライド間の余白
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    pagination: false,
    arrows: false, // デフォルトの矢印を非表示
    speed: 600,
    breakpoints: {
      599: {
        padding: "10%",
        gap: "20px",
      },
    },
  });

  // カウンターの処理
  const counterElLineup = document.querySelector(".lineup-slide__counter");

  if (counterElLineup) {
    const updateCounter = (index) => {
      counterElLineup.textContent = `${index + 1} / ${lineupSlider.length}`;
    };
    lineupSlider.on("mounted moved", () => updateCounter(lineupSlider.index));
  }

  // スライダーの初期化
  lineupSlider.mount();

  // 外部矢印ボタンの処理
  const prevBtnLineup = document.querySelector(
    ".lineup-slide__controls .splide__arrow--prev",
  );
  const nextBtnLineup = document.querySelector(
    ".lineup-slide__controls .splide__arrow--next",
  );

  if (prevBtnLineup && nextBtnLineup) {
    prevBtnLineup.addEventListener("click", () => lineupSlider.go("<"));
    nextBtnLineup.addEventListener("click", () => lineupSlider.go(">"));
  }
}

// =====================
// ずっと好きでいられる家づくりページ　追従メニュー
// =====================
document.addEventListener("DOMContentLoaded", () => {
  // 追従バナー本体を取得
  const ctaBanner = document.querySelector(".bottom-cta");

  // 監視ターゲット：ページ一番下のブロック（一般的な footer タグを指定）
  const targetFooter = document.querySelector("footer");

  // バナーが存在しないページでは処理を終了
  if (!ctaBanner) return;

  // 状態を管理するフラグ
  let isPassedTop = false; // 少しスクロールしたか
  let isReachedFooter = false; // フッターに到達したか

  // バナーの表示/非表示を切り替える関数
  const toggleBanner = () => {
    if (isPassedTop && !isReachedFooter) {
      // 少しスクロールしていて、かつフッターに到達していない時だけ表示
      ctaBanner.classList.add("is-show");
    } else {
      ctaBanner.classList.remove("is-show");
    }
  };

  // 1. トップからのスクロール量の監視（少しでもスクロールしたら表示）
  window.addEventListener(
    "scroll",
    () => {
      // 画面の一番上から 100px スクロールしたら true にする
      if (window.scrollY > 100) {
        isPassedTop = true;
      } else {
        isPassedTop = false;
      }
      toggleBanner();
    },
    {
      passive: true,
    },
  ); // passive: true をつけるとスクロールの動作が重くなりません

  // 2. フッターの監視（フッターが画面下部から見えてきたかどうか）
  if (targetFooter) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // フッターが画面に入ってきたら true
          isReachedFooter = entry.isIntersecting;
          toggleBanner();
        });
      },
      {
        // フッターが見える -100px 前に非表示にし始める
        rootMargin: "0px 0px -100px 0px",
        threshold: 0,
      },
    );

    footerObserver.observe(targetFooter);
  }
});
